var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.195 22.312A15.435 15.435 0 1 0 9.64 19.276c0 1.061.114 2.12.341 3.156a24.097 24.097 0 0 0-7.55 17.448 6.572 6.572 0 0 0 6.591 6.628l32.31-.129a6.583 6.583 0 0 0 6.552-6.68 24.11 24.11 0 0 0-7.689-17.387z",
    fill: "#1E184E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.113 28.653a9.47 9.47 0 1 1-.075-18.94 9.47 9.47 0 0 1 .075 18.94zm-.07-17.72a8.27 8.27 0 0 0-8.231 8.296 8.263 8.263 0 1 0 8.23-8.297z",
    fill: "#00A79E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41.309 40.395-32.31.128a.631.631 0 0 1-.603-.63 17.853 17.853 0 0 1 9.225-15.66.631.631 0 0 1 .809.242.586.586 0 0 1-.243.81 16.616 16.616 0 0 0-8.562 14.017l31.06-.123a16.604 16.604 0 0 0-8.654-13.937.6.6 0 0 1 .558-1.057 17.853 17.853 0 0 1 9.317 15.62.631.631 0 0 1-.597.634v-.044z",
    fill: "#00A79E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 35.165a2.841 2.841 0 1 1 2.644-1.758 2.849 2.849 0 0 1-2.644 1.758zm-.018-4.483a1.647 1.647 0 1 0 1.648 1.635 1.641 1.641 0 0 0-1.648-1.635zM35.154 37.338h-.088a.587.587 0 0 1-.508-.673l.546-3.923a2.809 2.809 0 0 0-2.45-3.146 2.923 2.923 0 0 0-2.125.526 2.672 2.672 0 0 0-1.085 1.803l-.552 3.923a.596.596 0 0 1-1.181-.166l.546-3.923a3.89 3.89 0 0 1 1.568-2.607 4.078 4.078 0 0 1 2.996-.738 4.003 4.003 0 0 1 3.47 4.469l-.552 3.923a.594.594 0 0 1-.585.532z",
    fill: "#00A79E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.718 36.884a1.571 1.571 0 1 1-3.11-.448 1.571 1.571 0 0 1 3.11.448zM26.75 35.49a1.578 1.578 0 1 0 3.117.494 1.578 1.578 0 0 0-3.117-.494zM17.046 30.434c-.07-.1-1.64-2.582-.942-5.047l1.15.33c-.548 1.896.786 4.038.8 4.056l-1.008.661zM33.746 29.231l-1.107-.45c.448-.99.556-2.1.31-3.158l1.147-.307a6.131 6.131 0 0 1-.35 3.915z",
    fill: "#00A79E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDoctor);
export default __webpack_public_path__ + "static/media/home-doctor.988701d504170759ad51aeff89ba983a.svg";
export { ForwardRef as ReactComponent };